import { render, staticRenderFns } from "./ReportP32Page.vue?vue&type=template&id=41dd49a0&"
import script from "./ReportP32Page.vue?vue&type=script&lang=js&"
export * from "./ReportP32Page.vue?vue&type=script&lang=js&"
import style0 from "./ReportP32Page.vue?vue&type=style&index=0&id=41dd49a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports